import { useQmsExamRoomStartExamMutation } from '../../generated/graphql';

export default useQmsExamRoomStartExamMutation;
